// src/services/api/offlineSales/orders.js
import { apiClient } from '../base';

export const getOrders = async (params = {}) => {
  const response = await apiClient.get('/offline-sales/orders', { params });
  return response.data;
};

export const getOrder = async (orderId) => {
  const response = await apiClient.get(`/offline-sales/orders/${orderId}`);
  return response.data;
};

export const createOrder = async (orderData) => {
  const response = await apiClient.post('/offline-sales/orders', orderData);
  return response.data;
};

export const updateOrder = async (orderId, updates) => {
  const response = await apiClient.put(`/offline-sales/orders/${orderId}`, updates);
  return response.data;
};

export const getSalesReps = async () => {
  const response = await apiClient.get('/offline-sales/orders/sales-reps');
  return response.data;
};

export const assignSalesRep = async (orderId, salesRepUserId) => {
  const response = await apiClient.put(`/offline-sales/orders/${orderId}/sales-rep`, { salesRepUserId });
  return response.data;
};

export const createQuickSaleOrder =async (orderData) => {
  const response = await apiClient.post('/offline-sales/orders/quick-sale', orderData);
  return response.data;
};

export const voidOrder = async (orderId, reason) => {
  const response = await apiClient.put(`/offline-sales/orders/${orderId}/void`, { reason });
  return response.data;
};

export const updateOnHoldOrder = async (orderId, updates) => {
  const response = await apiClient.put(`/offline-sales/orders/${orderId}`, updates);
  return response.data;
};

export const recordOrderPayment = async (orderId, paymentDetails) => {
  const response = await apiClient.post(`/offline-sales/orders/${orderId}/payments`, { paymentDetails });
  return response.data;
};

export const getOfflineOrderAuditHistory = async (orderId, params = {}) => {
  const response = await apiClient.get(`/offline-sales/orders/${orderId}/audit`, { params });
  return response.data;
};

export const getOfflineOrderAuditSummary = async (orderId) => {
  const response = await apiClient.get(`/offline-sales/orders/${orderId}/audit/summary`);
  return response.data;
};

export const getOrderReturns = async (orderId) => {
  const response = await apiClient.get(`/offline-sales/orders/${orderId}/returns`);
  return response.data;
};

export const getOrderStatusDistribution = async (params = {}) => {
  const response = await apiClient.get('/offline-sales/orders/status-distribution', { params });
  return response.data;
};

export const getSmsCapability = async () => {
  const response = await apiClient.get('/offline-sales/orders/sms-capability');
  return response.data;
};

export const sendInvoiceSms = async (orderId) => {
  const response = await apiClient.post(`/offline-sales/orders/${orderId}/send-invoice-sms`);
  return response.data;
};

// Mirrors src/services/api/orders.js's uploadOrderPaymentProof — same shape, offline-sales endpoint.
export const uploadOrderPaymentProof = async (file) => {
  const formData = new FormData();
  formData.append('paymentProof', file);
  const response = await apiClient.post('/offline-sales/orders/payment-proof', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.proofUrl;
};
